import { onError } from 'apollo-link-error'
import * as log from 'loglevel'
import store from '@/store'
import Raven from 'raven-js'

const link = onError(({ graphQLErrors }) => {
  if (graphQLErrors) {
    log.debug('GraphQL error encountered. Checking auth validity before reporting')
    store.dispatch('Auth/checkExpiration').then(() => {
      graphQLErrors.forEach(({ message, path, extensions }) => {
        log.error('GraphQL error', message, path, extensions)

        Raven.captureMessage(message, {
          tags: {
            resolver: path && path.length ? path[0] : 'unknown',
            transactionId: extensions && extensions.transactionId,
            code: extensions && extensions.code,
          },
        })

        switch (path[0]) {
          default: {
            // Nothing
          }
        }
      })
    })
  }
})

export default link



// WEBPACK FOOTER //
// ./src/graphql/error/index.js